export default "__VITE_ASSET__Dnaq$zjA__"